export const path = {
  HOME: '/',
  LOGIN: '/login',
  SEARCH_BY_DATE: '/search/date',
  SEARCH_BY_RECORD: '/search/record',
  SEARCH_BY_SPECIAL: '/search/special',
  PREVIEW: '/preview/:assetId',
  PREVIEW_TIME: `/preview/:assetId?in=:initInTime&out=:initOutTime&keyword=:initScript`,
  ERROR: '/error/:errorCode',
};
